import { motion } from "framer-motion";

type AnimatedDivHeaderProps = {
  title: string;
  icon?: React.ReactNode;
  showInfo?: boolean;
  onInfoClick?: () => void;
};

const AnimatedDivHeader = ({
  title,
  icon,
  showInfo = false,
  onInfoClick,
}: AnimatedDivHeaderProps) => {
  return (
    <div className="relative z-10 flex items-center justify-between mb-6">
      <div className="flex items-center gap-3">
        {icon}
        <h3 className="text-shopify-h2 text-shopify-light text-xl">{title}</h3>
      </div>

      {showInfo && (
        <motion.button
          whileHover={{ scale: 1.1, rotate: 180 }}
          whileTap={{ scale: 0.9 }}
          onClick={onInfoClick}
          className="
            w-8 h-8
            rounded-full
            bg-white/80
            text-slate-600
            text-sm
            hover:bg-white
            shadow-md
            hover:shadow-lg
            transition-all
            flex items-center justify-center
            border border-slate-200
          "
        >
          ℹ
        </motion.button>
      )}
    </div>
  );
};

export default AnimatedDivHeader;
